import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingSystemEntity  {
    _originalTypeClassName = "zERP.BO.AccountingSystemEntity";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingSystemEntity.translate = translateService;
}
this.Parameters = [];
this.Id = null;
this.ClassName = null;
this.FriendlyName = null;
this.ForTransactions = false;
this.ForAccounting = false;
this.ForCodeConfiguration = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ClassName:any;
FriendlyName:any;
ForTransactions:any;
ForAccounting:any;
ForCodeConfiguration:any;
Parameters:any;
static setParameters = ($this, items) => {
                if (items == null) items = [];
                if ($this.Parameters == null) $this.Parameters = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Parameters.length > 0) {
                    Domain.AccountingSystemEntity.removeParameters($this, $this.Parameters[0]);
                }

                Domain.AccountingSystemEntity.addManyParameters($this, copyItems);
            }
static addManyParameters = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingSystemEntity.addParameters($this, items[i]);
                }
            }
static addParameters = ($this, item) => {
                if ($this.Parameters == null) $this.Parameters = [];
                if (item == null || $this.Parameters.indexOf(item) > -1) return;
                $this.Parameters.push(item);
}
static addRangeParameters = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingSystemEntity.addParameters($this, item));
            }
static removeParameters = ($this, item) => {
                if ($this == null || $this.Parameters == null || $this.Parameters.indexOf(item) === -1) return;
                var _index = $this.Parameters.indexOf(item);
                $this.Parameters.splice(_index, 1);
}
static clearParameters = ($this) => { $this.Parameters = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}